// extracted by mini-css-extract-plugin
export default {"searchBar":"SearchBar_searchBar__sq7rG","icon":"SearchBar_icon__vkZ8i"};